class CartDrawer extends Drawer {

    constructor() {
        super();
        this.isDesktop = window.innerWidth > 1024;

        const opener = this.isDesktop
            ? document.querySelector('#cart-icon-bubble')
            : document.querySelector('#cart-icon-bubble-mobile');

        this.setIconAccessibility(opener);
        subscribe(PUB_SUB_EVENTS.cartUpdate,() => {
            super.setListeners()
        })
    }

    connectedCallback() {
        this.updateOpener();

        window.addEventListener('resize', this.updateOpener.bind(this));
    }
    disconnectedCallback() {
        window.removeEventListener('resize', this.updateOpener.bind(this));
    }
    updateOpener() {
        this.isDesktop = window.innerWidth > 1024;

        this.opener = this.isDesktop
            ? document.querySelector('#cart-icon-bubble')
            : document.querySelector('#cart-icon-bubble-mobile');

        this.setIconAccessibility(this.opener);
        subscribe(PUB_SUB_EVENTS.cartUpdate,() => {
            super.setListeners()
        })

    }
    open() {
        super.open();
    }

    renderContents(parsedState) {
        const details = this.querySelector('[data-details]')
        details.classList.contains('is-empty') &&
        details.classList.remove('is-empty');
        this.getSectionsToRender().forEach((section) => {
            const sectionElement = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);

            if (!sectionElement) return;
            sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });

        setTimeout(() => {
            this.open();
            super.setListeners()
        });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
        return [
            {
                id: 'cart-drawer',
                selector: '#CartDrawer',
            },
            {
                id: 'cart-icon-bubble',
            },
            {
                id: 'cart-icon-bubble-mobile',
            },
        ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    setActiveElement(element) {
        this.activeElement = element;
    }

}

if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
}

class CartDrawerItems extends CartItems {
    getSectionsToRender() {
        return [
            {
                id: 'CartDrawer',
                section: 'cart-drawer',
                selector: '[data-details]',
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section',
            },
            {
                id: 'cart-icon-bubble-mobile',
                section: 'cart-icon-bubble-mobile',
                selector: '.shopify-section',
            },
        ];
    }
}

customElements.define('cart-drawer-items', CartDrawerItems);